// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2s-6";
export var headerCell = "_2s-2";
export var loadingStateContent = "_2s-8";
export var rowWrapper = "_2s-4";
export var stickyAggregationCell = "_2s-b";
export var stickyAggregationRow = "_2s-7";
export var stickyColumnCell = "_2s-a";
export var stickyColumnHeaderCell = "_2s-9";
export var table = "_2s-1";
export var virtualRowWrapper = "_2s-5";
export var virtualTableBodyFiller = "_2s-d";
export var virtualTableBodyFillerBottom = "_2s-e";
export var virtualTableContainer = "_2s-0";
export var virtualTableContainerFill = "_2s-c";
export var white = "_2s-3";